import { render, staticRenderFns } from "./DoublePieChart.vue?vue&type=template&id=8b1f2896&"
import script from "./DoublePieChart.vue?vue&type=script&lang=js&"
export * from "./DoublePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports